"use strict";

exports.__esModule = true;
exports.ToolBarItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconClickable = require("../../Elements/IconClickable/IconClickable");
var _Text = require("../../Elements/Text/Text");
var _Breadcrumb = require("../Breadcrumb/Breadcrumb");
var _ContextMenu = require("../../Compositions/ContextMenu/ContextMenu");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ToolBarItem = ({
  config,
  selectedItem,
  setSelectedItem
}) => {
  const {
    type,
    text,
    linkTo,
    onHandle,
    icon,
    iconAlign,
    sections,
    routerLink
  } = config;
  const iconCss = {
    clkContainerCssModifier: 'tool-bar',
    lblContainerCssModifier: 'mobile-hidden'
  };
  const classes = ['ccl-e-tool-bar__item__filter'];
  if (selectedItem === icon) classes.push('ccl-e-tool-bar__item__filter__selected');
  switch (type.toLowerCase()) {
    case 'chevron-left':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
          id: "Prev",
          config: iconCss,
          handleClick: onHandle,
          leftIcon: {
            color: 'interactive',
            flip: '',
            size: 'sm',
            type: 'chevron-left'
          },
          link: linkTo,
          text: text,
          type: type.toLowerCase(),
          routerLink: routerLink
        });
      }
    case 'chevron-right':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
          id: "Next",
          config: iconCss,
          handleClick: onHandle,
          link: linkTo,
          rightIcon: {
            color: 'interactive',
            size: 'sm',
            type: 'chevron-right'
          },
          text: text,
          type: type.toLowerCase(),
          routerLink: routerLink
        });
      }
    case 'button':
      {
        const iconConfig = {
          color: 'interactive',
          size: 'sm',
          type: icon
        };
        const leftIconConfig = iconAlign === 'left' ? iconConfig : null;
        const rightIconConfig = iconAlign === 'right' ? iconConfig : null;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
          id: icon,
          config: iconCss,
          handleClick: onHandle,
          link: linkTo,
          leftIcon: leftIconConfig,
          rightIcon: rightIconConfig,
          text: text,
          type: type.toLowerCase()
        });
      }
    case 'hyperlink':
      {
        const iconConfig = {
          color: 'interactive',
          size: 'sm',
          type: icon
        };
        const leftIconConfig = iconAlign === 'left' ? iconConfig : null;
        const rightIconConfig = iconAlign === 'right' ? iconConfig : null;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
          id: icon,
          config: iconCss,
          handleClick: onHandle,
          link: linkTo,
          leftIcon: leftIconConfig,
          rightIcon: rightIconConfig,
          text: text,
          type: type.toLowerCase()
        });
      }
    case 'filter-button':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.join(' '),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
            id: icon,
            config: iconCss,
            handleClick: () => {
              setSelectedItem(icon);
              onHandle(icon);
            },
            link: linkTo,
            leftIcon: {
              color: 'interactive',
              size: 'sm',
              type: icon
            },
            text: text,
            type: type.toLowerCase(),
            routerLink: routerLink,
            analytics: config.analytics
          })
        });
      }
    case 'text-filter-button':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.join(' '),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
            id: text,
            clkContainerCssModifier: "tool-bar",
            lblContainerCssModifier: "inline",
            handleClick: () => {
              setSelectedItem(icon);
              onHandle(icon);
            },
            link: linkTo,
            text: text,
            type: type.toLowerCase(),
            routerLink: routerLink
          })
        });
      }
    case 'context-menu':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl-e-tool-bar__item__mobile",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextMenu.ContextMenu, {
            id: "context-menu",
            icon: icon,
            size: "small",
            items: sections
          })
        });
      }
    case 'breadcrumb':
      {
        const breadcrumbItems = sections.map(section => ({
          id: '',
          linkTo: '',
          text: section.text,
          handleClick: section.action,
          routerLink
        }));
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumb.Breadcrumb, {
          items: breadcrumbItems
        });
      }
    case 'text':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
          content: text
        });
      }
    default:
      {
        return undefined;
      }
  }
};
exports.ToolBarItem = ToolBarItem;